import React from 'react';
import { ModalOverlay, ModalContentWrapper, CloseButton } from './overshadowingPopup.styled'

const ModalHandler = ({ isOpen, onClose, children, noCloseIcon, maxWidth, maxHeight, maxWidthMobile, maxHeightMobile, mobileWidth, mobileHeight}) => {
  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContentWrapper 
        $maxWidth={maxWidth}
        $maxHeight={maxHeight}
        $maxWidthMobile={maxWidthMobile}
        $maxHeightMobile={maxHeightMobile}
        $mobileWidth={mobileWidth}
        $mobileHeight={mobileHeight}
      >
        {noCloseIcon ? <></> : <CloseButton onClick={onClose}>&times;</CloseButton>}
        {children}
      </ModalContentWrapper>
    </>
  );
};

export default ModalHandler;